module.exports = __webpack_public_path__ + "img/avatar2.388ec397.png";